module.exports = __webpack_public_path__ + "static/media/diary.f5ae9f75.svg";